// Pending note edits capture their target thread at edit time. The debounced
// save must never derive the thread id from the currently open thread: an edit
// made on thread A while the user switches to thread B within the debounce
// window would otherwise overwrite B's note (PRO: premote data-loss incident).

export interface PendingNoteSave {
	threadId: string
	text: string
	baselineText: string
}

export function capturePendingNoteSave(
	thread: { id: string; text: string | null },
	html: string,
	prev: PendingNoteSave | null,
): PendingNoteSave {
	if (prev && prev.threadId === thread.id) {
		return { ...prev, text: html }
	}
	return { threadId: thread.id, text: html, baselineText: thread.text ?? "" }
}

export function resolvePendingNoteSave(
	pending: PendingNoteSave | null,
): { id: string; text: string } | null {
	if (!pending) return null
	if (pending.text === pending.baselineText) return null
	return { id: pending.threadId, text: pending.text }
}

// Advances the baseline to what was just persisted, so a later revert to the
// pre-edit text still saves instead of being read as "nothing changed".
export function markPendingNoteSaved(
	prev: PendingNoteSave | null,
	saved: { id: string; text: string },
): PendingNoteSave | null {
	if (!prev || prev.threadId !== saved.id) return prev
	return { ...prev, baselineText: saved.text }
}
